import React from "react";
import PropTypes from "prop-types";
import { IoIosArrowRoundUp } from "react-icons/io";
import DataTable from "react-data-table-component";

import "./DataTableStyles.scss";
import Pagination from "../../controls/Pagination/Pagination";

const DataTableView = ({
  title,
  paginationServer = true,
  pagination = true,
  paginationPerPage,
  currentPage,
  extraStyles,
  extraStylesForTable,
  displayDescription,
  displayActionButtonComponent,
  ...props
}) => {
  const PaginationComponent = () => {
    return (
      <Pagination
        rowsPerPage={paginationPerPage}
        currentPage={currentPage}
        rowCount={props.paginationTotalRows}
        onChangePage={props.onChangePage}
        onChangeRowsPerPage={props.onChangeRowsPerPage}
        displayDescription={displayDescription}
        displayActionButtonComponent={displayActionButtonComponent}
      />
    );
  };
  return (
    <div className={`data_table ${extraStyles}`}>
      <DataTable
        title={<h3 className={`H2 ${title ? "mb-4" : "mb-0"}`}>{title}</h3>}
        // className={"dataTable"}
        className={`dataTable ${extraStylesForTable}`}
        sortIcon={<IoIosArrowRoundUp />}
        pagination={pagination}
        paginationServer={paginationServer}
        paginationComponent={PaginationComponent}
        {...props}
      />
    </div>
  );
};

DataTableView.propTypes = {
  title: PropTypes.string,
  paginationServer: PropTypes.bool,
  pagination: PropTypes.bool,
};

export default DataTableView;
